/** Lot Reservations — whole lots held for an export order. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { ReservationsPage } from "@/features/inventory/reservations/reservations-page";
import { useDeskFacility } from "@/features/warehouse/route-helpers";

const search = z.object({
  tab: z.enum(["active", "ended"]).default("active").catch("active"),
});

export const Route = createFileRoute("/_app/inventory/reservations")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("inventory.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReservationsPage
      facilityId={useDeskFacility() ?? undefined}
      tab={tab}
      onTab={(t) => void navigate({ search: { tab: t }, replace: true })}
    />
  );
}
